import React, { Component } from 'react';
import { IOrderTypeChooserProps, IOrderTypeChooserState } from './OrderTypeChooser.types';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import './OrderTypeChooser.scss';

/**
 * Renders a selectbox where all the available forms is selectable. 
 * The button becomes active only if the selectbox value is not 0; which acts as a placeholder.
 */
export class OrderTypeChooser extends Component<IOrderTypeChooserProps, IOrderTypeChooserState> {
  static defaultProps = {
    values: [],
    fieldName: ''
  } as IOrderTypeChooserProps;

  constructor(props: IOrderTypeChooserProps) {
    super(props);
    this.state = {
      disabled: true,
      selectBoxValue: '0'
    };
  }

  onChange = (e: FormField<string>) => {
    const disabled = e.value === '0';
    this.setState({
      selectBoxValue: e.value,
      disabled
    });
  };

  public render() {
    const { values, fieldName } = this.props;
    const { selectBoxValue, disabled } = this.state;
    return (
      <div>
        <form method="post" className="addorder-form">
          <SelectBox
            onChange={this.onChange}
            className="addorder-selectbox"
            options={values}
            value={selectBoxValue}
            fieldName={fieldName}
            disableDefaultOption={true}
          />

          <div className="addorder-form-submit">
            <input
              disabled={disabled}
              name="action:Order"
              type="submit"
              className={`button ${disabled ? 'button--disabled' : ''}`}
              value="Starta beställning"
            />
          </div>
        </form>
      </div>
    );
  }
}
